/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon[_ngcontent-%COMP%]{background:0 0;border:none;cursor:pointer;padding-top:14px;padding-left:10px;padding-right:10px}.checkbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{vertical-align:middle;position:relative;display:inline-block;margin-bottom:5px}.checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{vertical-align:middle;padding-left:10px;display:inline-block}"];
export { styles as styles };
